import React, { Fragment, useContext, useEffect, useState } from "react";
import AppContext from "../../Store/AppContext";
import { ObterIndicadorHome } from "../../Services/Indicadores";
import MinhasMetas from "./Components/MinhasMetas/MinhasMetas";
import MeusResultados from "./Components/MeusResultados/MeusResultados";
import AtendimentoOportunidades from "./Components/AtendimentoOportunidades/AtendimentoOportunidades";
import BonusTrimestral from "./Components/BonusTrimestral/BonusTrimestral";
import "./IndicadoresHome.css";

const tituloTela = "Início";

const IndicadoresHome = () => {
  const { setTituloTela } = useContext(AppContext);
  const [abaAtiva, setAbaAtiva] = useState("metas");
  const [dados, setDados] = useState({});
  const [atualizacao, setAtualizacao] = useState("");

  useEffect(() => {
    setTituloTela(tituloTela);

    async function carregarIndicadores() {
      const { success, indicadores } = await ObterIndicadorHome();
      if (success) {
        const mapeado = {};
        indicadores.forEach(({ chave, valor }) => {
          mapeado[chave] = isNaN(valor) ? valor : parseFloat(valor);
        });
        setDados(mapeado);
        setAtualizacao(mapeado["GERAL_ATUALIZACAO"]);
      }
    }

    carregarIndicadores();
  }, [setTituloTela]);

  return (
    <Fragment>
      {/* Botões */}
      <div className="d-flex justify-content-center mb-4 mt-5 flex-wrap">
        <button className={`btn btn-outline-secondary mx-1 ${abaAtiva === "metas" ? "active-indicador-btn" : ""}`} onClick={() => setAbaAtiva("metas")}>Minhas Metas</button>
        <button className={`btn btn-outline-secondary mx-1 ${abaAtiva === "resultados" ? "active-indicador-btn" : ""}`} onClick={() => setAbaAtiva("resultados")}>Meus Resultados</button>
        <button className={`btn btn-outline-secondary mx-1 ${abaAtiva === "atendimentos" ? "active-indicador-btn" : ""}`} onClick={() => setAbaAtiva("atendimentos")}>Atendimentos / Oportunidades</button>
        <button className={`btn btn-outline-secondary mx-1 ${abaAtiva === "bonus" ? "active-indicador-btn" : ""}`} onClick={() => setAbaAtiva("bonus")}>Bônus Trimestral</button>
      </div>

      {/* Conteúdo */}
      <div className="d-flex justify-content-center">
        <div className="indicador-content-wrapper">
          {abaAtiva === "metas" && (
            <MinhasMetas
              metaMensal={dados["METAS_MENSAL"]}
              clientesCarteira={dados["METAS_CLIENTES"]}
              ticketMedio={dados["METAS_TICKET"]}
              metaTrimestralAtual={dados["METAS_TRIMESTRE_ATUAL"]}
              metaTrimestralTotal={dados["METAS_TRIMESTRE_TOTAL"]}
              dataAtualizacao={atualizacao}
            />
          )}

          {abaAtiva === "resultados" && (
            <MeusResultados
              valorVendido={dados["RESULT_VENDIDO"]}
              leadsPerdidos={dados["RESULT_LEADS_PERDIDOS"]}
              dataDe={dados["RESULT_DATA_DE"]}
              dataAte={dados["RESULT_DATA_ATE"]}
              faturamentoTotal={dados["RESULT_FATURAMENTO"]}
              dataAtualizacao={atualizacao}
            />
          )}

          {abaAtiva === "atendimentos" && (
            <AtendimentoOportunidades
              leadsAtendidos={dados["ATEND_LEADS"]}
              apolicesEmitidas={dados["ATEND_APOLICES_EMITIDAS"]}
              apolicesPendentes={dados["ATEND_APOLICES_PENDENTES"]}
              dataAtualizacao={atualizacao}
            />
          )}

          {abaAtiva === "bonus" && (
            <BonusTrimestral
              valorAtual={dados["BONUS_ATUAL"]}
              valorMeta={dados["BONUS_META"]}
              dataAtualizacao={atualizacao}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default IndicadoresHome;
